module.exports = __webpack_public_path__ + "assets/images/scene-4_113590c4256b935b839a1a901b0de295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/croma-abeldo-dialogs/scene-4.png
// module id = 222
// module chunks = 0